module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_17.fb599ffa.pdf";